import AddPropertyConstants from '../../../constants/AddPropertyConstants';

type BehaviorOption =
  (typeof AddPropertyConstants.BEHAVIOR_OPTIONS)[keyof typeof AddPropertyConstants.BEHAVIOR_OPTIONS];

/**
 * Determines whether the Room for Rent checkbox should be displayed
 * based on property type and behavior mode.
 *
 * The checkbox is only shown when:
 * - Property is not a multiplex
 * - Property is not a community type
 * - Behavior is in ADD mode (not EDIT)
 */
export const shouldDisplayRoomForRentCheckbox = (
  isMultiplexType: boolean,
  isCommunityType: boolean,
  behavior: BehaviorOption,
): boolean => {
  return !isMultiplexType && !isCommunityType && behavior === AddPropertyConstants.BEHAVIOR_OPTIONS.ADD;
};
